import React, { useCallback, useEffect, useState } from "react";
import FullScreenSection from "./FullScreenSection";
import { Box, Heading, SimpleGrid, Button, Flex, Img } from "@chakra-ui/react";
import Card from "./Card";
import Arrow from "../images/arrow.png";

const ProjectsSection = () => {
  const defaultProject = [
    {
      title: "Skigames",
      description:
        "Prototipo di e-Commerce di videogiochi realizzato in Javascript Vanilla, realizzato come progetto finale del Bootcamp con Aulab",
      display: true,
      visible: true,
      getImageSrc: () => require("../images/skig.png"),
    },
    {
      title: "Trident",
      description:
        "Web App sviluppata con React che permette all'utente di accedere ad alcune funzionalità protette tramite un sistema di autenticazione basato sul localStorage.",
      display: true,
      visible: true,
      getImageSrc: () => require("../images/multiapp.png"),
    },
    {
      title: "Work in progress..",
      description: "Sezione in costante aggiornamento",
      display: false,
      visible: false,
      getImageSrc: () => require("../images/Work-In-Progress.png"),
    },
  ];

  const [filteredProjects, setFilteredProjects] = useState(defaultProject);

  const handleSwitch = useCallback(() => {
    let updatedProjs = filteredProjects
      .filter((el) => !el.display)
      .map((el) => {
        return {
          ...el,
          display: true,
        };
      });
    setFilteredProjects(updatedProjs);
  }, [filteredProjects]);

  useEffect(() => {
    if (filteredProjects.length === 0) {
      setFilteredProjects(defaultProject);
    }
  }, [handleSwitch]);

  return (
    <FullScreenSection
      backgroundColor='#14532d'
      isDarkBackground
      p={8}
      alignItems='flex-start'
      spacing={8}
      id='projects-section'
    >
      <Heading as='h1' mt='10'>
        Progetti
      </Heading>
      <Flex justifyContent='center'>
        <Box display='flex' alignItems='center'>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} mt={8}>
            {filteredProjects.map((el, index) => {
              return (
                el.display &&
                index !== 2 && (
                  <Box width={"100%"}>
                    <Card
                      title={el.title}
                      description={el.description}
                      imageSrc={el.getImageSrc()}
                      isDisabled={!el.visible}
                    />
                  </Box>
                )
              );
            })}
          </SimpleGrid>
          <Img
            className='button-4'
            onClick={handleSwitch}
            src={Arrow}
            display={"block"}
            id='arrow'
            marginLeft='20px'
            marginRight='-100px'
            marginTop='-100px'
          />
        </Box>
      </Flex>
    </FullScreenSection>
  );
};

export default ProjectsSection;
